import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Tooltip from "wonderbly-components/lib/Tooltip";

const BreadCrumbItem = (props) => (
  <div
    className={cx("breadcrumb-item", {
      "breadcrumb-item--active": props.isActive,
    })}
  >
    {props.label && (
      <Tooltip absolute visible noPadding tooltipAlignment="above" type="alert">
        {props.label}
      </Tooltip>
    )}
    <img
      loading="lazy"
      className="breadcrumb-item-image"
      onClick={props.onClick}
      src={props.image.url}
      alt={props.image.alt || ""}
    />
    {props.textOverlay && (
      <span className="breadcrumb-item-text-overlay">{props.textOverlay}</span>
    )}
  </div>
);

BreadCrumbItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  textOverlay: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }).isRequired,
};

export default BreadCrumbItem;
